const StageOrientation = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  NONE: 'none',
};

export default StageOrientation;
